module.exports = __webpack_public_path__ + "static/media/home-video.690f1f46.mp4";